import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalUpdateDescription, setSelectedServiceItemDescription, deleteMessage }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "desc",
        Header: "توضیحات ",
        minWidth: 120,
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Button
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              onClick={() => {
                setSelectedServiceItemDescription(row.original);
                setShowModalUpdateDescription(true);
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>
            <Button
              className="btn btn-light-danger btn-sm btn-icon "
              onClick={() => {
                setSelectedServiceItemDescription(row.original);
                deleteMessage(row.original);
              }}
            >
              <i className="far fa-trash-alt text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: false,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
